/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* TLS: tag the mega menu panel so CSS can target it reliably */
document.addEventListener('DOMContentLoaded', function () {
  // Tag common Warehouse mega menu containers with a universal class
  document.querySelectorAll('.mega-menu__panel, [data-mega-menu], .mega-menu').forEach(function (el) {
    el.classList.add('tls-mega');
  });
});

/*
 * WO-2026-041 — Bob Pay pre-payment returns/refund/cancellation acceptance gate.
 *
 * Bob Pay requires the relevant policy to be disclosed and positively accepted before
 * final payment. The full cart is the single controlled storefront checkout entry point:
 * product accelerated checkout is suppressed in Liquid/CSS and drawer checkout routes
 * here. The checked cart attribute is submitted with the cart so it can follow the order
 * as evidence where Shopify preserves cart attributes.
 */
(function () {
  var POLICY_PATH = '/policies/refund-policy';
  var ACCEPTANCE_ATTRIBUTE = 'Returns/refund/cancellation policy accepted';
  var POLICY_URL_ATTRIBUTE = 'Returns/refund/cancellation policy URL';

  function installCartPolicyGate() {
    if (!window.theme || window.theme.pageType !== 'cart') {
      return;
    }

    var form = document.querySelector('form.cart-recap');
    var checkoutButton = form && form.querySelector('button[name="checkout"]');

    if (!form || !checkoutButton) {
      return;
    }

    var existingGate = form.querySelector('[data-tls-policy-acceptance]');
    if (existingGate) {
      document.body.classList.add('tls-compliance-gate-ready');
      return;
    }

    var policyUrl = (window.routes && window.routes.rootUrlWithoutSlash ? window.routes.rootUrlWithoutSlash : '') + POLICY_PATH;
    var gate = document.createElement('div');
    gate.className = 'tls-policy-acceptance';
    gate.setAttribute('data-tls-policy-acceptance', '');

    gate.innerHTML = [
      '<p class="tls-policy-acceptance__title"><strong>Returns, refunds &amp; cancellations</strong></p>',
      '<p class="tls-policy-acceptance__intro">Before continuing to checkout, please read our <a class="link link--accented" href="' + policyUrl + '">Returns, Refunds &amp; Cancellations Policy</a>.</p>',
      '<label class="tls-policy-acceptance__choice" for="tls-policy-acceptance-checkbox">',
      '  <input id="tls-policy-acceptance-checkbox" type="checkbox" name="attributes[' + ACCEPTANCE_ATTRIBUTE + ']" value="Accepted before checkout" required aria-describedby="tls-policy-acceptance-error">',
      '  <span>I have read and accept the Returns, Refunds &amp; Cancellations Policy.</span>',
      '</label>',
      '<input type="hidden" name="attributes[' + POLICY_URL_ATTRIBUTE + ']" value="' + policyUrl + '">',
      '<p id="tls-policy-acceptance-error" class="tls-policy-acceptance__error" role="alert" hidden>Please accept the Returns, Refunds &amp; Cancellations Policy before continuing to checkout.</p>'
    ].join('');

    checkoutButton.parentNode.insertBefore(gate, checkoutButton);

    var checkbox = gate.querySelector('#tls-policy-acceptance-checkbox');
    var policyUrlInput = gate.querySelector('input[name="attributes[' + POLICY_URL_ATTRIBUTE + ']"');
    var error = gate.querySelector('#tls-policy-acceptance-error');

    // Preserve the canonical policy URL as an explicit cart attribute.  Setting the
    // property after insertion protects the evidence value if a storefront script
    // normalises dynamically-created hidden inputs.
    if (policyUrlInput) {
      policyUrlInput.value = policyUrl;
      policyUrlInput.setAttribute('value', policyUrl);
    }

    // Fail closed: checkout remains disabled until positive acceptance in this cart view.
    checkoutButton.disabled = true;
    checkoutButton.setAttribute('aria-disabled', 'true');

    checkbox.addEventListener('change', function () {
      var accepted = checkbox.checked;
      checkoutButton.disabled = !accepted;
      checkoutButton.setAttribute('aria-disabled', accepted ? 'false' : 'true');
      checkbox.removeAttribute('aria-invalid');
      error.hidden = true;
    });

    if (form.dataset.tlsPolicyGateBound !== 'true') {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        var isCheckoutSubmit = !submitter || submitter.name === 'checkout';

        // Reassert immediately before serialization: the platform cart may rebuild
        // attribute fields after this gate is installed.
        if (isCheckoutSubmit && policyUrlInput) {
          policyUrlInput.value = policyUrl;
          policyUrlInput.setAttribute('value', policyUrl);
        }

        if (isCheckoutSubmit && !checkbox.checked) {
          event.preventDefault();
          checkbox.setAttribute('aria-invalid', 'true');
          error.hidden = false;
          checkbox.focus();
        }
      });

      form.dataset.tlsPolicyGateBound = 'true';
    }

    document.body.classList.add('tls-compliance-gate-ready');
  }

  document.addEventListener('DOMContentLoaded', installCartPolicyGate);

  // Warehouse may replace cart markup after quantity changes. Re-install the gate if
  // the cart recap is re-rendered, without duplicating controls or listeners.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      installCartPolicyGate();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
